var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"icon-wrapper",style:({'--color':_vm.color}),on:{"click":function($event){return _vm.$emit('click', $event)}}},[_c('svg-icon',{attrs:{"name":"main/close"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }